/*
 * @Description:
 * @Date: 2025-07-28 18:05:39
 */
import { WarningFilled } from '@element-plus/icons-vue';
import { useTableColumn, BaseIcon, BasePopover } from 'xrk-components';
import { formatter } from '@/utils';
import { INVOICE_STATUS } from '@V/invoice/src/constants';

/** 开票状态 */
export const invoiceStatusCol = useTableColumn({
  label: '开票状态',
  prop: 'invoiceStatus',
  width: '180px',
  render: ({ row, cellValue }) => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <span>
          {formatter.defaultFormat(
            cellValue,
            () => INVOICE_STATUS[cellValue].label
          )}
        </span>
        {/* 已驳回。申请红冲被驳回(驳回的是待红冲，未到红票审核)时，状态回退到已开票(蓝票)的情况下展示驳回原因 */}
        {[2, 3, 7].includes(cellValue) && row.noPassReason && (
          <BasePopover
            placement="top"
            width="300px"
            title="驳回原因"
            trigger="hover"
            content={row.noPassReason}
            disabled={false}
            v-slots={{
              reference: () => (
                <BaseIcon>
                  <WarningFilled />
                </BaseIcon>
              )
            }}
          />
        )}
      </div>
    );
  }
});
